import { ViewMore } from '@/javascripts/view_more';
import Attachment from '@/javascripts/attachment';
import CommentForm from '@/javascripts/comment_form';
import ImageZoomer from '@/javascripts/components/ImageZoomer';
import ReportReasonModal from '@/javascripts/report_reason_modal';
import InfiniteScroll from '@/javascripts/components/infinite_scroll';
import Confirm from '@/javascripts/components/Confirm';
import ReplyOmitted from '@/javascripts/components/reply_omitted';
import ReplyCollapse from '@/javascripts/components/reply_collapse';
import Mute from '@/javascripts/components/Mute';
import Mention from '@/javascripts/components/Mention';
import { Favorite } from '@/javascripts/components/Favorite';
import { mountReactComponents } from '@/utils/react_mount';
import { communityComponents } from '@/components/mountable/registry';

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.ImageZoomer = ImageZoomer;
window.Coorum.CommentForm = CommentForm;
window.Coorum.Attachment = Attachment;
window.Coorum.Mute = Mute;
window.Coorum.Mention = Mention;

const mute = new window.Coorum.Mute();

$(() => {
  new ReplyOmitted('.js-reply-omitted');
  new ReplyCollapse('.js-reply-collapse');
  const commentRootElement = document.querySelector('.comments-content');
  const comments = document.querySelectorAll('.p-answer');

  comments.forEach((comment) => {
    mute.setMuteActions({ dataType: 'User', rootElement: comment });
    mute.setMuteActions({ dataType: 'Chat', rootElement: comment });
    mute.addToggleMuteEvent({ rootElement: comment });
  });

  // 初回読み込みイベント
  addActionEvent(document);
  new ViewMore('#view_more', '.loading-image');
  new Favorite('.js-favorite', {
    button: { toggleMethod: ['post', 'delete'] },
  });
  const imageZoomer = new window.Coorum.ImageZoomer();
  imageZoomer.setGeneralEvent();
  const editorElement = document.getElementById('editor');
  if (editorElement) {
    imageZoomer.setEditorEvent(editorElement);
  }
  new window.Coorum.CommentForm('.js-comment-form');
  document.querySelectorAll('[id^="report-reason-modal-"]').forEach((modal) => {
    new ReportReasonModal(modal.id);
  });
  document
    .querySelectorAll('.js-attachment')
    .forEach((elem) => new window.Coorum.Attachment({ spacing: 12 }, elem, true));
  InfiniteScroll.init('.comments-container', '.p-answer', '.js-paginate a');

  const answerForm = $('.answer_form');
  const mentionEl = answerForm.find('.js-mention').get(0);
  if (mentionEl && !mentionEl.closest('[data-react-mounted]')) {
    answerForm.show();
    new Mention(mentionEl as HTMLInputElement).setEvents();
  }

  $(document).on('click', '.js-answer_reply_btn', function () {
    $('.js-answer_reply_form').hide();
    const replyForm = $(`.js-answer_reply_form[data-chat_comment-id="${$(this).data('chat_comment-id')}"]`).show();
    const replyMentionEl = replyForm.find('.js-mention').get(0) as HTMLInputElement | undefined;
    if (replyMentionEl) {
      if (replyMentionEl.closest('[data-react-mounted]')) {
        replyMentionEl.dispatchEvent(
          new CustomEvent('mention:set-value', { detail: { value: $(this).data('user-id') as string } }),
        );
      } else {
        replyMentionEl.value = $(this).data('user-id');
        new Mention(replyMentionEl).setEvents();
      }
    }
    const headerHeight = $('.st-Header').height() || 0;
    const offsetTop = (replyForm.offset()?.top || 0) - headerHeight - 50;
    $('html, body').animate({ scrollTop: offsetTop }, 1000);
  });

  // 検知イベント
  const replyWrappers = document.querySelectorAll('.sent-replies');
  const replyMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          new ReplyOmitted('.js-reply-omitted', node);
        });
    });
  });
  replyWrappers.forEach((replyWrapper) => {
    replyMutation.observe(replyWrapper, { childList: true });
  });

  const documentMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          mute.setMuteActions({ dataType: 'User', rootElement: node });
          mute.setMuteActions({ dataType: 'Chat', rootElement: node });
        });
    });
  });
  documentMutation.observe(document.body, { childList: true });

  if (commentRootElement) {
    const commentRootMutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
          .forEach((node) => {
            // 追加読み込み/新規投稿されたコメント内の React いいね/リアクション/一覧モーダルをマウント
            mountReactComponents(communityComponents, node as HTMLElement);
            new window.Coorum.ImageZoomer().setGeneralEvent(node);
            if ((node as HTMLElement).dataset.newComment === 'false') {
              Confirm.setEvents(node);
            }
            const attachment = node.querySelector('.js-attachment');
            if (attachment) {
              new window.Coorum.Attachment({ spacing: 12 }, attachment, true);
            }
            mute.addToggleMuteEvent({ rootElement: node });
            addActionEvent(node);

            node.querySelectorAll('[id^="report-reason-modal-"]').forEach((modal) => {
              new ReportReasonModal(modal.id);
            });
            new ReplyOmitted('.js-reply-omitted', node);
            new ReplyCollapse('.js-reply-collapse', node);

            node.querySelectorAll('.sent-replies').forEach((replyWrapper) => {
              replyMutation.observe(replyWrapper, { childList: true });
            });
          });
      });
      // AJAX 投稿後の prepend や infinite scroll で追加されたコメント内の返信フォームに対し、
      // CommentForm のダブルクリック / Enter 連打防止ハンドラを再 init する。
      // 初回 DOMContentLoaded 時点で DOM に存在しなかった form は登録されないため、
      // ここで再走しないと動的に追加された返信フォームの連打防御だけが効かなくなる。
      new window.Coorum.CommentForm('.js-comment-form');
    });
    commentRootMutation.observe(commentRootElement, { childList: true });
  }
});

// 三点リーダーのボタンをクリックした時に表示を切り替えるイベントを登録する
function addActionEvent(rootElement: Document | Element = document) {
  rootElement.querySelectorAll('.js-action_btn').forEach((button) => {
    button.addEventListener('click', () => {
      button.querySelector('.js-action_body')?.classList.toggle('block');
    });
  });
}
